// 2026-08 (owner request) — ONE captain marker everywhere.
// Matches mobile TeamManagement's badge: 16px gold circle, black "C",
// thin background-colored ring. Used by TeamManagement, StageArenaView
// (Stage arena + rival TeamViewPage) and FormationView.
export const CaptainBadge = ({ className = '' }) => (
  <span
    aria-label="Team captain"
    data-testid="captain-badge"
    className={`absolute -top-1.5 -right-1.5 z-10 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background bg-[hsl(43,74%,52%)] text-[10px] font-extrabold leading-none text-[#171724] shadow-sm ${className}`}
  >
    C
  </span>
);
